import { render } from "./RuleWords.vue?vue&type=template&id=6fe28654"
import script from "./RuleWords.vue?vue&type=script&lang=js"
export * from "./RuleWords.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__